import {DataStatus} from 'platform/components';

import {useGetNoteQuery, useUpdateNoteMutation} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';
import {handleApiError, NoteCard as NoteCardComponent, NoteCardForm} from '@dms/shared';

import {TestIdProps, useIsLoadingWithInitialError} from 'shared/web';

interface NoteCardProps extends TestIdProps {
  customerId: string;
}

export function NoteCard(props: NoteCardProps) {
  const {
    data,
    isLoading: isNoteLoading,
    isError,
  } = useGetNoteQuery({
    resourceId: EntityResourceIds.customer,
    recordId: props.customerId,
    context: 'DEFAULT',
  });
  const [saveCustomerNote, {isLoading: isSaveLoading}] = useUpdateNoteMutation();

  const isLoading = useIsLoadingWithInitialError(isNoteLoading, isError);

  const onChange = (values?: NoteCardForm) =>
    saveCustomerNote({
      resourceId: EntityResourceIds.customer,
      recordId: props.customerId,
      context: 'DEFAULT',
      updateNoteRequestBody: {
        text: values?.note ?? '',
      },
    })
      .unwrap()
      .catch(handleApiError);

  return (
    <DataStatus isLoading={isLoading} minHeight={52}>
      <NoteCardComponent
        authorId={data?.updatedBy ?? undefined}
        note={data?.text ?? null}
        datetime={data?.updatedAt}
        isLoading={isSaveLoading}
        onChange={onChange}
        data-testid={props['data-testid']}
      />
    </DataStatus>
  );
}
